import {
  GET_CUSTOMERS,
  GET_CUSTOMER,
  CREATE_CUSTOMER,
  REMOVE_CUSTOMER,
  UPDATE_CUSTOMER,
} from './types';

export const getCustomers = (companyId) => ({
  type: GET_CUSTOMERS,
  request: {
    method: 'GET',
    url: `/company/${companyId}/customers`,
  },
  meta: {
    thunk: true,
  },
});

export const getCustomer = (companyId, customerId) => ({
  type: GET_CUSTOMER,
  customerId,
  request: {
    method: 'GET',
    url: `/company/${companyId}/customers/${customerId}`,
  },
  meta: {
    thunk: true,
  },
});

export const createCustomer = (companyId, payload) => ({
  type: CREATE_CUSTOMER,
  request: {
    method: 'POST',
    url: `/company/${companyId}/customers`,
    data: payload,
  },
  meta: {
    thunk: true,
  },
});

export const removeCustomer = (companyId, customerId) => ({
  type: REMOVE_CUSTOMER,
  customerId,
  request: {
    method: 'DELETE',
    url: `/company/${companyId}/customers/${customerId}`,
  },
  meta: {
    thunk: true,
  },
});

export const updateCustomer = (companyId, customerId, payload) => ({
  type: UPDATE_CUSTOMER,
  customerId,
  request: {
    method: 'PATCH',
    url: `/company/${companyId}/customers/${customerId}`,
    data: payload,
  },
  meta: {
    thunk: true,
  },
});
